import { AxiosInstance } from 'axios';
import { simulate } from './utils';
import { UserDiscount } from 'referral-types';

export const baseEndpoint = 'user-discount';

export class UserDiscountApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getDiscounts(): Promise<Array<UserDiscount>> {
    await simulate();

    const response = await this.apiInstance.get(`/`);
    
    return response.data; 
  }

  async claimDiscount(groupReferralId: string): Promise<Array<UserDiscount>> {
    await simulate();

    const response = await this.apiInstance.post(`/${groupReferralId}`);
    
    return response.data; 
  }
}
